import AdminConsoleSchoolsDirectoryPage from "@/admin/AdminConsoleSchoolsDirectoryPage";
import withAdminPrivileges from "@/admin/withAdminPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";

import { DirectoryPageAuxiliaryDataProvider } from "@/admin/useDirectoryPageAuxiliaryDataContext/useDirectoryPageAuxiliaryDataContext";

const AdminConsoleSchoolsDirectoryPageRoute = () => {
  return (
    <NewselaGlobalLayout
      mainContents={
        <DirectoryPageAuxiliaryDataProvider>
          <AdminConsoleSchoolsDirectoryPage />
        </DirectoryPageAuxiliaryDataProvider>
      }
    />
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}
export default withAdminPrivileges(AdminConsoleSchoolsDirectoryPageRoute);
